import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { UpdateReactionEmojiPayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useAddReaction = () => {
  const { updateReactions } = useConversationQueryCache();
  const { reactions } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: UpdateReactionEmojiPayload) => {
      const result = await reactions.updateReactionEmoji(payload);

      return result.data;
    },
    onSuccess: (reactions, payload) => {
      updateReactions(payload.conversationId, payload.messageId, reactions);
    },
  });

  return mutation;
};
